import { useState, useCallback } from 'react';
import { CalculatorSettings, DEFAULT_CALCULATOR_SETTINGS } from '../types';

export const STORAGE_KEY = 'roiInsights.calculatorSettings';

const loadFromStorage = (): CalculatorSettings => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_CALCULATOR_SETTINGS;
    const parsed = JSON.parse(raw);
    return {
      costPerCall:
        typeof parsed.costPerCall === 'number' ? parsed.costPerCall : DEFAULT_CALCULATOR_SETTINGS.costPerCall,
    };
  } catch {
    return DEFAULT_CALCULATOR_SETTINGS;
  }
};

export const useCalculatorSettings = (): [CalculatorSettings, (next: CalculatorSettings) => void] => {
  const [settings, setSettingsState] = useState<CalculatorSettings>(loadFromStorage);

  const setSettings = useCallback((next: CalculatorSettings) => {
    setSettingsState(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // ignore — quota exceeded or storage disabled; in-memory state still reflects the change
    }
  }, []);

  return [settings, setSettings];
};
